module.exports = "mat-table[name=\"tablaResponsables\"] .mat-column-acciones {\n  min-width: 84px; }\n"